/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import axios from "axios";
import store from "../../store/index";
// import moment from "moment";
// import { ref } from 'vue'
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    parentfolderlist: {
      type: Array,
      default: () => [],
    },
    patid: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: true,
    },
    showLoader:{
      type: Boolean,
      default: false,
    },
    showSideButton:{
      type: Boolean,
      default: true,
    },
    boldfolder: {
      type: String,
      default: "",
    },
    restoreOnMount: { type: Boolean, default: true },
  },
  data() {
    return {
       patientid: "",
      listdata: [],
      ancestors: [],
      openfolder: "",

      // Caches / UI state (Vue2-safe maps)
      loadedOnce: {},
      userpermissions: [],
      foldertreelist: {},
      hasChildList: {},
      showTreeLoader: {},
      showFolderLoading: {},   // FIX: was array; should be object
      folderswitch: {},

      firstclassname: this.patid,
      folderbyid: "",
      currentselectedfolder: "",
      selectedboldfolder: "",
      previousChild: "",
      showDetails: false,
      anyuserpermissions: false,
      showBlock: false,

      arrayfolders: [],
      openfolderlist: [],
      baseurl: process.env.VUE_APP_Service_URL,
      alreadyOpened: [],

      // NEW: phase flag mirrors prop and gets passed to children
      restorePhase: this.restoreOnMount,
    };
  },
  beforeRouteEnter(to, from, next) {
    const previousRouteName = from.name;
    next((vm) => (vm.previousRouteName = previousRouteName));
    console.log("previousroutename",previousRouteName);
  },
  
  async beforeMount() {
    await this.setlist();
    this.arrayfolders = store.getters.getFolderDetails;
  },
  async mounted() {
    let previousroute = store.getters.getPrevRoute;
    if(previousroute == "documentview"){
    this.openfolderlist = store.getters.getnewopenfolderlist || [];
    }
    if (this.previousRouteName === "folderDocLogin") {
      this.openfolder = store.getters.getopenfolder || this.boldfolder || "";
      if (this.openfolder) {
        this.currentselectedfolder = this.openfolder;
        await this.getAncestors(this.openfolder);
      }
    }

    // One-time restore (propagates to children because we pass :restoreOnMount="restorePhase")
    if (this.restorePhase) {
      await this.restoreOpenState();
      await this.restoreSelectedOnLoad();
      this.restorePhase = false; // turn off for any mounts after user clicks
    }
  },
  
  watch: {
    "$store.getters.getFolder": async function (val) {
      if (store.getters.geteditfolderid) {
        // this.currentselectedfolder = val;
        await this.getLastAncestor(store.getters.geteditfolderid);
      }
    },
    boldfolder(newVal) {
      this.currentselectedfolder = newVal;
    },
  },
  methods: {
    async emitTypeFor(id) {
  if (this.foldertreelist[id]?.length) {
    this.$emit("folderType", this.foldertreelist[id][0].type || "0");
  } 
},
    async restoreOpenState() {
      // Only restore ids that exist at this level
      const idsAtThisLevel = new Set(this.list.map((x) => x.id));
      for (const tag of this.openfolderlist) {
        const id = tag.replace(/^etmf-/, "");
        if (idsAtThisLevel.has(id)) {
          await this.getFolderChildren(id, { select: false, ensureOpen: true });
        }
      }
    },
     async restoreSelectedOnLoad() {
  const selectedId =
    this.$store.getters.getFolderId ||
    this.$store.getters.getopenfolder ||
    this.boldfolder ||
    "";

  if (!selectedId) return;

  // make sure store + local highlight are in sync
  this.$store.dispatch("setFolderId", selectedId);
  this.currentselectedfolder = selectedId;

  // ensure it’s opened (no toggle) and trigger the same side-effects
  await this.getFolderChildren(selectedId, { select: true, ensureOpen: true });

  // re-emit type so the parent can load docs
  await this.emitTypeFor(selectedId);

  this.$nextTick(() => {
    const el = document.getElementById(`etmf-${selectedId}`);
    if (el) el.scrollIntoView({ block: "nearest", inline: "nearest" });
  });
},
    collapseDescendants(rootId) {
      const stack = (this.foldertreelist[rootId] || []).map((c) => c.id);
      const toClose = [];
      while (stack.length) {
        const nodeId = stack.pop();
        if (this.folderswitch[nodeId]) toClose.push(nodeId);
        const kids = this.foldertreelist[nodeId];
        if (kids && kids.length) {
          for (const child of kids) stack.push(child.id);
        }
      }
      for (const id of toClose) {
        this.folderswitch = { ...this.folderswitch, [id]: false };
        const tag = `etmf-${id}`;
        const idx = this.openfolderlist.indexOf(tag);
        if (idx !== -1) this.openfolderlist.splice(idx, 1);
      }
      store.dispatch("setnewopenfolderlist", this.openfolderlist);
    },
    folderFunctionality(type, popupId, ancestors) {
      this.closePopover(popupId);
      const eventMap = {
        edit: "editFolder",
        add: "addFolder",
        delete: "deleteFolder",
        archive: "archiveFolder",
        clone: "cloneFolder",
        export: "exportFolder",
        permission: "addFolderPermission",
        share: "shareFolderPermission",
        upload: "uploadDocument",
        emptyChild: "emptyChild",
        exportFolderTreeStructure: "exportFolderTreeStructure",
        folderType: "folderType",
        selectedfoldertype:"selectedfoldertype"
      };
      const eventName = eventMap[type];
      if (!eventName) return;
      if (eventName !== "editFolder" && eventName !== "archiveFolder") {
        this.$emit(eventName, ancestors);
      } else {
        this.$emit(eventName);
      }
    },
    handleInnerFunc(type, ancestors) {
      this.folderFunctionality(type, null, ancestors);
    },
    async closePopover(id) {
      document.getElementById(id)?document.getElementById(id).hidePopover():null
    },
    async setlist() {
      this.listdata = [...this.list];
    },
     async openSidePopup(elem) {
      this.showFolderLoading = { ...this.showFolderLoading, [elem.id]: true };
      try {
        store.dispatch("setFolderId", elem.id);
        this.getFolderUserpermission(elem.id);
        const idtoken = store.getters.getIdToken;
        const res = await axios.get(
          `${this.baseurl}/etmf/folder/getprivilegedchildren?Id=${elem.id}&StudyId=${store.getters.getStudyIs}&condition=site`,
          { headers: { Authorization: "Bearer " + idtoken } }
        );
        this.hasChildList = { ...this.hasChildList, [elem.id]: res.data };
        if (this.hasChildList[elem.id]?.length) {
          this.$emit("folderType", this.hasChildList[elem.id][0].type || "0");
        } else {
          await this.checkType(elem.id);
        }
      } catch (err) {
        console.log(err.message);
      } finally {
        this.showFolderLoading = { ...this.showFolderLoading, [elem.id]: false };
      }
    },
     async checkType(elem) {
      try {
        const idtoken = store.getters.getIdToken;
        const res = await axios.get(
          `${this.baseurl}/etmf/folder/getnextfoldertype?parentId=${elem}&studyId=${store.getters.getStudyIs}`,
          { headers: { Authorization: "Bearer " + idtoken } }
        );
        this.$emit(
          "folderType",
          res.data && res.data.inferredType ? res.data.inferredType : ""
        );
      } catch (err) {
        console.log(err.message);
      }
    },

    async getInitialTree(id){
      if (this.alreadyOpened.includes(id)) {
        console.debug(`Skipping ${id}, already opened`)
        return
      }
      else{        
        this.alreadyOpened.push(id)
        this.getFolderChildren(id)
      }
    },
    async getFolderChildren(
      id,{elem = null}={},
      { select = true, ensureOpen = false, reload = false } = {}
    ) {
      console.log("passed element = ", elem);
      const token = store.getters.getIdToken;
      const url = `${this.baseurl}/etmf/folder/getprivilegedchildren?Id=${id}&StudyId=${store.getters.getStudyIs}&condition=site`;

      // COLLAPSE (user toggle)
      if (!ensureOpen && this.folderswitch[id]) {
        this.folderswitch = { ...this.folderswitch, [id]: false };

        // keep selection on collapse (better UX). Remove if you want to clear.
        // if (select && this.currentselectedfolder === id) {
        //   store.dispatch("setFolderId", "");
        //   this.currentselectedfolder = "";
        //   this.$emit("folderType", "");
        // }

        // Close all descendants
        this.collapseDescendants(id);

        // Remove this id from persisted open list
        const tag = `etmf-${id}`;
        const idx = this.openfolderlist.indexOf(tag);
        if (idx !== -1) this.openfolderlist.splice(idx, 1);
        await store.dispatch("setnewopenfolderlist", this.openfolderlist);

        this.showTreeLoader = { ...this.showTreeLoader, [id]: false };
        return;
      }

      // Ensure open (no toggle if ensureOpen)
      if (!this.folderswitch[id]) {
        this.folderswitch = { ...this.folderswitch, [id]: true };
      }

      // Selection & persistence
      if (select) {
        store.dispatch("setFolderId", id);
        this.currentselectedfolder = id;
      }
      const tag = `etmf-${id}`;
      if (!this.openfolderlist.includes(tag)) {
        this.openfolderlist.push(tag);
        await store.dispatch("setnewopenfolderlist", this.openfolderlist);
      }

      // Fetch only once unless reload requested
      const needFetch = reload || !this.loadedOnce[id];
      if (!needFetch) {
        if (select) {
          if (this.foldertreelist[id]?.length) {
            this.$emit("folderType", this.foldertreelist[id][0].type || "");
           this.$emit("selectedfoldertype", this.elem);
            // this.$emit("folderType", this.foldertreelist[id][0].type || "");
          } else {
            await this.checkType(id);
          }
        }
        return;
      }

      // Fetch children
      this.showTreeLoader = { ...this.showTreeLoader, [id]: true };
      try {
        const res = await axios.get(url, {
          headers: { Authorization: "Bearer " + token },
        });

        this.foldertreelist = { ...this.foldertreelist, [id]: res.data };
        this.loadedOnce = { ...this.loadedOnce, [id]: true };

        if (select) {
          if (this.foldertreelist[id]?.length) {
            this.$emit("folderType", this.foldertreelist[id][0].type || "");
          } else {
            await this.checkType(id);
          }
        }
      } catch (err) {
        console.error("Error fetching folder children:", err);
      } finally {
        this.showTreeLoader = { ...this.showTreeLoader, [id]: false };
      }

      this.getFolderUserpermission(id);
    },
    async getFolderUserpermission(id) {
      this.userpermissions = [];
      try {
        const idtoken = store.getters.getIdToken;
        const res = await axios.get(
          `${this.baseurl}/etmf/folderfilepermission/getuserfolderpermission?FolderId=${id}`,
          { headers: { Authorization: "Bearer " + idtoken } }
        );
        this.userpermissions = res.data || [];
        const visible = [
          "Clone",
          "Permissions",
          "Share",
          "Edit",
          "Delete",
          "Archive",
          "Download",
          "Add",
          "Upload",
          "Folder Structure Export",
        ];
        this.anyuserpermissions = this.userpermissions.some((p) =>
          visible.includes(p)
        );
      } catch (err) {
        console.log(err);
      } finally {
        this.showFolderLoading = { ...this.showFolderLoading, [id]: false };
      }
    },
    async getAncestors(folderid) {
      if (!folderid) return;
      try {
        const idtoken = store.getters.getIdToken;
        const res = await axios.get(
          `${this.baseurl}/etmf/folder/getfolderbyid?Id=${folderid}&StudyId=${store.getters.getStudyIs}`,
          { headers: { Authorization: "Bearer " + idtoken } }
        );
        this.ancestors = res.data.ancestorIds || [];
        await this.setFolderStruct(folderid);
      } catch (err) {
        console.log(err);
      }
    },
     async setFolderStruct(folderid) {
      for (const eachid of this.ancestors) {
        await this.getAncestorFolder(eachid);
      }
      await this.getAncestorFolder(folderid);
    },
    async getAncestorFolder(id) {
      if (!this.folderswitch[id]) {
        this.folderswitch = { ...this.folderswitch, [id]: true };
      }
      // open without toggling, no selection, load if needed
      await this.getFolderChildren(id, { select: false, ensureOpen: true });
    },
    async reloadallfolders() {
      for (const element of this.list) {
        if (this.folderswitch[element.id]) {
          await this.refreshfolder(element.id);
        }
      }
    },
    async refreshfolder(id) {
      if (!this.folderswitch[id]) return;
      await this.getFolderChildren(id, {
        select: false,
        ensureOpen: true,
        reload: true,
      });
    },
    async getLastAncestor(id) {
      try {
        const idtoken = store.getters.getIdToken;
        const res = await axios.get(
          `${this.baseurl}/etmf/folder/getfolderbyid?Id=${id}&StudyId=${store.getters.getStudyIs}`,
          { headers: { Authorization: "Bearer " + idtoken } }
        );
        const editedfolderdetails = res.data.ancestorIds || [];
        const lastancestor = editedfolderdetails[editedfolderdetails.length - 1];
        // If you want, replace DOM clicks with setFolderId + ensureOpen chain
        document.getElementById(lastancestor + "doc")?.click();
        document.getElementById(lastancestor + "doc")?.click();
        document.getElementById(res.data.id + "doc")?.click();
        store.dispatch("seteditfolderid", "");
      } catch (err) {
        console.log(err);
      }
    },
  },
};